import { ArtifactInstance, ArtifactDef, MuseumBuyerDef, Rarity, GAME_CONFIG } from '../types';
import { RNG } from '../utils/RNG';

const RARITY_MEDIA_VALUES: Record<Rarity, number> = {
  common: 500,
  uncommon: 1500,
  rare: 5000,
  legendary: 15000,
  mythical: 25000,
};

export class Economy {
  money: number = 5000;
  income: number[] = [];
  expenses: number[] = [];

  sellArtifact(
    artifact: ArtifactInstance,
    def: ArtifactDef,
    buyer: MuseumBuyerDef,
    buyerRelationship: number
  ): number {
    const price = this.getOffer(artifact, def, buyer, buyerRelationship);
    this.money += price;
    this.income.push(price);
    artifact.sold = true;
    return price;
  }

  getOffer(
    artifact: ArtifactInstance,
    def: ArtifactDef,
    buyer: MuseumBuyerDef,
    buyerRelationship: number
  ): number {
    const conditionMult = GAME_CONFIG.conditionMultipliers[artifact.condition];
    const rarityMult = GAME_CONFIG.rarityMultipliers[def.rarity];
    const relationshipMult = 1 + buyerRelationship / 200;

    let price = def.baseValue * conditionMult * rarityMult * buyer.baseMultiplier * relationshipMult;

    if (buyer.preferredTypes.includes(def.type)) {
      price *= 1.2;
    }
    if (buyer.preferredEras.includes(def.era)) {
      price *= 1.2;
    }

    return Math.round(price);
  }

  applyExhibitionIncome(visitorSatisfaction: number, displayCount: number): number {
    const dailyIncome = Math.round(displayCount * 50 * (visitorSatisfaction / 100));
    this.money += dailyIncome;
    this.income.push(dailyIncome);
    return dailyIncome;
  }

  applyForGrant(reputation: number, rng: RNG): { success: boolean; amount: number } {
    const chance = (40 + reputation * 0.5) / 100;
    const success = rng.chance(chance);

    if (success) {
      const amount = rng.range(2000, 10000);
      this.money += amount;
      this.income.push(amount);
      return { success: true, amount };
    }

    return { success: false, amount: 0 };
  }

  getMediaDeal(rarity: Rarity, reputation: number): number {
    const base = RARITY_MEDIA_VALUES[rarity];
    const deal = Math.round(base * (1 + reputation / 100));
    this.money += deal;
    this.income.push(deal);
    return deal;
  }

  payDailyExpenses(crewWages: number, museumUpkeep: number): number {
    const total = crewWages + museumUpkeep;
    this.money -= total;
    this.expenses.push(total);
    return total;
  }

  spend(amount: number): boolean {
    if (this.money < amount) {
      return false;
    }
    this.money -= amount;
    this.expenses.push(amount);
    return true;
  }

  canAfford(amount: number): boolean {
    return this.money >= amount;
  }
}
